import { combineReducers } from "redux";
import { Constant } from "../../Constant";

const profile = (state = {}, action) => {
    let { type, payload } = action;
    switch (type) {
        case Constant.action.GET_IAMSMART_PROFILE.DONE:
            return { ...state, ...payload };
        case Constant.action.RESET_TOKEN:
            return {};
        default:
            return state;
    }
};

const fieldMap = (state = {}, action) => {
    let { type, payload } = action;
    switch (type) {
        case Constant.action.INIT_IAMSMART_FIELD_MAP:
            return payload;
        case Constant.action.SET_IAMSMART_FIELD_MAP:
            return { ...state, ...payload };
        case Constant.action.UPDATE_IAS_FIELD:
            return {
                ...state,
                [payload]: { ...state[payload], isChanged: true },
            };
        case Constant.action.RESET_TOKEN:
            return {};
        case Constant.action.RESET_FORMFILLED:
            return {
                ...state,
                formFilled: false,
            };
        default:
            return state;
    }
};

const iasTokenMap = (state = {}, action) => {
    let { type, payload } = action;
    switch (type) {
        case Constant.action.INIT_IAMSMART_IASTOKEN_FIELD_MAP:
            return payload;
        default:
            return state;
    }
};

const iamsmart = combineReducers({
    profile,
    fieldMap,
    iasTokenMap,
});

export default iamsmart;
